/**
 * La caja «Ante el SAT» de la ficha (corte 2 de los certificados del SAT): la arma el servicio, que es su dueño porque el PDF del Buscador
 * también la pinta (app/nexo-investigator/src/ante-el-sat.ts, sin copiarla aquí, como shared/rotulos/mesa.ts con los textos de la mesa).
 * Aquí sólo se le pasa el documento y la forma de escribir una fecha de las pantallas. Sin React ni red: la usan la ficha de Argus Team y
 * la de Nexo (que la importa de aquí, como lib/ficha.ts).
 */
import type { Hallazgos } from '@piezas';
import { fechaLlana } from '@piezas';
import { SAT } from '@rotulos';
import { textosDeVista, vistaDeAnteElSat } from '../../../../nexo-investigator/src/ante-el-sat.ts';
import type { AnteElSatDoc, VistaAnteElSat } from '../../../../nexo-investigator/src/ante-el-sat.ts';

export type { DatoSat, EnListaSat, LineaSat, TarjetaVista, VistaAnteElSat } from '../../../../nexo-investigator/src/ante-el-sat.ts';

/** La caja de un documento, o null si el sujeto no tiene certificados (la ficha de siempre). */
export const vistaAnteElSat = (doc: Hallazgos): VistaAnteElSat | null =>
  vistaDeAnteElSat(doc.ante_el_sat as AnteElSatDoc | undefined, doc.sujeto.tipo, fechaLlana);

/**
 * De dónde sale una frase o un dato que no se abre (decisión 9: «Certificado del SAT»): un certificado del SAT o la consulta de la CURP,
 * con su fecha si la trae. Las demás fuentes se abren con «Ver la fuente»: null.
 */
export function fuenteSinCopia(f: { tipo: string; fecha?: string | null } | null | undefined): string | null {
  if (!f || (f.tipo !== 'certificado_sat' && f.tipo !== 'consulta_curp')) return null;
  const rotulo = f.tipo === 'certificado_sat' ? SAT.fuenteCertificado : SAT.fuenteConsulta;
  return f.fecha ? `${rotulo}, ${fechaLlana(f.fecha)}` : rotulo;
}

/** Los textos de la caja (para la prueba W2: todo texto visible está en el documento o en un catálogo). */
export const textosAnteElSat = (doc: Hallazgos): string[] => textosDeVista(vistaAnteElSat(doc));
